import React, { useState, useRef, useEffect } from 'react';
import '../../styles/ui/EmojiPicker.css';

// Kurált emoji-készlet a partner-kategóriákhoz — nem teljes Unicode-könyvtár,
// hanem a tipikus szolgáltatás-témákra szűkítve (nincs külső függőség).
const EMOJIS = [
  '🔧', '🔨', '🪛', '🪚', '🧰', '⚡', '💡', '🔌', '🚰', '🚿',
  '🏊', '🏡', '🏠', '🌳', '🌿', '🪴', '🧹', '🧽', '🧼', '🗑️',
  '🔥', '❄️', '🌡️', '🛠️', '🔩', '🪟', '🚪', '🔒', '🔑', '📹',
  '🚗', '🚚', '🛻', '⛽', '🐜', '🐛', '🎨', '🧱', '🏗️', '📦',
  '📶', '📡', '🛎️', '📋', '✅', '☎️', '✉️', '🗺️', '⭐', '🤝',
];

const EmojiPicker = ({ value, onChange, placeholder = '🔧' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const pick = (emoji) => {
    onChange(emoji);
    setOpen(false);
  };

  return (
    <div className="emoji-picker" ref={ref}>
      <div className="emoji-picker-input-row">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={10}
        />
        <button
          type="button"
          className="emoji-picker-trigger"
          onClick={() => setOpen((o) => !o)}
          aria-haspopup="true"
          aria-expanded={open}
          title="Emoji picker"
        >
          {value || '🙂'}
        </button>
      </div>
      {open && (
        <div className="emoji-picker-grid" role="listbox">
          {EMOJIS.map((e) => (
            <button
              type="button"
              key={e}
              className={`emoji-picker-cell${value === e ? ' emoji-picker-cell--active' : ''}`}
              onClick={() => pick(e)}
              role="option"
              aria-selected={value === e}
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
